export const channels = [
  {
    name: 'Key Metrics By Store',
    value: 'key-metrics-by-store',
    enabled: true
  },
  {
    name: 'Key Metrics By Expert',
    value: 'key-metrics-by-expert',
    enabled: true
  },
  {
    name: 'Key Metrics',
    value: 'key-metrics',
    enabled: true
  },
  {
    name: 'UPR By Expert',
    value: 'upr-by-expert',
    enabled: true
  },
  {
    name: 'UPR By Store',
    value: 'upr-by-store',
    enabled: true
  }
];